export default __webpack_public_path__ + "static/media/breakfast_3.84f2422e.jpg";